import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Picture } from '@app/core/business/picture';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { environment } from '@env/environment';

/** CLA le 01/02/2019
 * Permet de gérer le rendu d'une image d'un produit
 */
@Component({
  selector: 'app-product-picture',
  templateUrl: './product-picture.component.html',
  styleUrls: ['./product-picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPictureComponent implements OnInit, OnChanges {

  @Input()
  picture: Picture;

  @Input()
  productCode: string;

  /**
   * URL utilisée dans le style de la div afin d'afficher l'image du produit
   */
  public pictureStyleUrl: SafeStyle;

  /**
   * Pour récupérer l'URL de base pour récupérer une image produit
   */
  public environment = environment;
  
  constructor(
    //private changeDetector: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // Au chargement du composant, chargement de l'image
    this.updatePicture();
  }

  /**
   * Permet de recharger l'image
   */
  private updatePicture() {
    if (this.picture) {
      // L'URL de style est traitée pour être de confiance
      this.pictureStyleUrl = this.sanitizer.bypassSecurityTrustStyle(
        `url(${environment.baseFileUrl + this.picture.url})`
      );
    }
  }

  /** 
   * Au changement du contexte du composant
   */
  ngOnChanges() {
    // Au changement, rechargement de l'image
    this.updatePicture();
  }
}